import React, { useState } from 'react';
// import PropTypes from 'prop-types';
import ReactTable from 'react-table';
import { Card, CardHeader, Collapse } from 'reactstrap';
import { UpOutlined, DownOutlined } from '@ant-design/icons';
import CustomCell from './subcomponents/CustomItemCell';
import Header from './subcomponents/Header';
import WSCodes from '../../../config/SegCCodeDef.json';

const column1 = [
  {
    Header: 'Weapons System Name',
    accessor: 'wsName',
  },
  // {
  //   Header: <Header title="WSDC" tooltip={WSCodes.WSDC.definition} />,
  //   accessor: 'WSDC',
  //   Cell: cellProps => (
  //     <CustomCell title={cellProps.value} tooltip={[cellProps.value]} />
  //   ),
  // },
  // ask about WSDC
  {
    Header: 'WSDC',
    accessor: 'WSDC',
  },

  {
    Header: <Header title="WSEC" tooltip={WSCodes.WSEC.definition} />,
    accessor: 'WSEC',
    Cell: cellProps => <CustomCell type="WSEC" value={cellProps.value} />,
  },

  {
    Header: <Header title="WSIC" tooltip={WSCodes.WSIC.definition} />,
    accessor: 'WSIC',
    Cell: cellProps => <CustomCell type="WSIC" value={cellProps.value} />,
  },

  {
    Header: <Header title="WSGC" tooltip={WSCodes.WSGC.definition} />,
    accessor: 'WSGC',
    Cell: cellProps => <CustomCell type="WSGC" value={cellProps.value} />,
  },
];

const Table = data => {
  const [toggleQuestion, setToggequestion] = useState(1);
  return (
    <div className="nf-u-details__grid">
      <Card className="nf-solicitation-detail__card">
        <CardHeader
          className="nf-solicitation-detail__card-header"
          onClick={() => setToggequestion(!toggleQuestion)}
        >
          Weapon Systems Designator Codes
          {toggleQuestion ? <UpOutlined /> : <DownOutlined />}
        </CardHeader>

        <Collapse isOpen={toggleQuestion}>
          <ReactTable
            data={data.block}
            columns={column1}
            defaultPageSize={data.block.length > 0 ? data.block.length : 3}
            style={{ textAlign: 'left' }}
            showPagination={false}
          />
        </Collapse>
      </Card>
      {/* <Table dataSource={drawings} columns={columns} /> */}
    </div>
  );
};

export default Table;



// WEBPACK FOOTER //
// ./src/pages/universalDetails/niinDetailTables/WSDC.jsx